<template>
    <div class="fitpanel" style="display:none">
      <div class="cursor" v-on:click="scale('Minus');showinfo=true">
        <svg  xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 39.214 39.214">
          <path fill="#ffffff" d="M52.256,47.635l-8.295-8.295a16.368,16.368,0,1,0-4.621,4.621l8.295,8.295a3.267,3.267,0,0,0,4.621-4.621ZM18.9,30.339A11.437,11.437,0,1,1,30.339,41.776,11.45,11.45,0,0,1,18.9,30.339Z" transform="translate(-14 -14)"/>
          <path fill="#ffffff" d="M45.58,33.484a1.658,1.658,0,0,1-1.658,1.658H30.658a1.658,1.658,0,1,1,0-3.316H43.922A1.658,1.658,0,0,1,45.58,33.484Z" transform="translate(-20.916 -17.11)"/>
        </svg>
      </div>
      <div class="fitpaneltext cursor" v-on:click="showinfo =! showinfo"> {{value }} </div>
      <div class="cursor" v-on:click="scale('Plus');showinfo=true">
        <svg  xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 39.214 39.214">
          <path fill="#ffffff"d="M52.256,47.635l-8.295-8.295a16.368,16.368,0,1,0-4.621,4.621l8.295,8.295a3.267,3.267,0,0,0,4.621-4.621ZM18.9,30.339A11.437,11.437,0,1,1,30.339,41.776,11.45,11.45,0,0,1,18.9,30.339Z" transform="translate(-14 -14)"/>
          <path fill="#ffffff"  d="M45.58,37.29a1.658,1.658,0,0,1-1.658,1.658H38.948v4.974a1.658,1.658,0,0,1-3.316,0V38.948H30.658a1.658,1.658,0,1,1,0-3.316h4.974V30.658a1.658,1.658,0,1,1,3.316,0v4.974h4.974A1.658,1.658,0,0,1,45.58,37.29Z" transform="translate(-20.916 -20.916)"/>
        </svg>
      </div>
    <!--  <div class="fit-info"  v-if="showinfo" v-on:click="showinfo=false"> {{value }} </div>-->

    </div>
</template>

<script>
  import en from '../../i18n/en_US';
  import fr from '../../i18n/fr_FR';
  import Mixin from '../../mixins/Mixin.js';
  export default {
    name: 'panelFitScreen',
    mixins: [Mixin],
    data(){
      return{
        showinfo:false,
        value:'100%',
        defaultScaling : 100
      }
    },
    i18n: {
      messages: {
        en,
        fr,
      },
    },
    mounted() {
      let self = this;
      eventHub.$on('updateDefaultValue', self.updateDefaultValue);
      eventHub.$on('scaleDefaultValue', self.scaleDefaultValue);


    },
    methods:{
      updateDefaultValue(value){
        if(value){
          setTimeout(() => {
            this.value = value.percent+"%";
            this.defaultScaling = value.percent;
            let height = (document.querySelector('.canvas-div').offsetHeight   / (document.querySelector('.canvas-div .gjs-frame').offsetHeight ))*100;
            let width = (document.querySelector('.canvas-div').offsetWidth  / (document.querySelector('.canvas-div .gjs-frame').offsetWidth  ))*100;
            let tx = (Math.min(height,width).toFixed(1) > 99 ? 0 : document.querySelector('.canvas-div').offsetWidth-(document.querySelector('.canvas-div .gjs-cv-canvas').offsetWidth*value.percent/100));
            this.scaleValue('.customScale',value.percent/100,((value.ty/2)),tx > 0 ? (-tx/2)+20 : 0)
            this.scale('Minus');
          },100)

        }

      },
      scaleDefaultValue(){

        this.scaleValue('.customScale',this.defaultScaling,0,0,1)

      },
      scale(type) {
        let Styletransform = document.querySelector('.customScale');
        const style = getComputedStyle(Styletransform);
        let valuetransform = parseFloat(style.transform.replace(/\(|\)|matrix/g, '').split(',')[0]);
        let ty = parseFloat(style.transform.replace(/\(|\)|matrix/g, '').split(',')[5]);
        let tx = parseFloat(style.transform.replace(/\(|\)|matrix/g, '').split(',')[4]);

        if (type === "Minus" && valuetransform > 0.1) {
          valuetransform = valuetransform - 0.1;
          this.defaultScaling = valuetransform;
          this.scaleValue('.customScale',valuetransform,ty,tx,1)
        }
        if (type === "Plus" && valuetransform < 1) {
          valuetransform = valuetransform + 0.1;
          this.defaultScaling = valuetransform;
          this.scaleValue('.customScale',valuetransform,ty,tx,-1)

        }

        this.value=  (valuetransform * 100).toFixed(0) +'%'

      },
    },
  };
</script>

<style scoped>
.fitpanel{
  display: inline-flex;
  position: absolute;
  z-index: 4;
  align-items: center;
  padding-top: 10px;
  color: white;
  left: calc(50% - 80px);
}
  .fitpaneltext{
    margin-left: 10px;
    margin-right: 10px;
  }
  .cursor{
    cursor: pointer;
  }
  .fit-info{
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    position: absolute;
    left: 36%;
    top: 2.5em;
    color: black;
    z-index: 110;
    max-width: 276px;
    text-align: left;
    background-color: #ffffff;
    background-clip: padding-box;
    border: 1px solid #869098;
    border-radius: 6px;
    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    white-space: normal;
}

.fit-info:before {
  z-index: 100;
  content: '';
  position: absolute;
  width: 10px;
  height: 10px;
  left: 40%;
  top: -6px;
  box-sizing: border-box;
  background-color:#ffffff ;
  border-left: 1px solid #869098;
  border-top: 1px solid #869098;
  transform: rotate(45deg);

}

</style>



// WEBPACK FOOTER //
// panelFitScreen.vue?495cc185